import React from 'react'
import { IToothDetails } from '@dataTypes/appointment.type'
import { ProcedureSurfaceSelectionRules } from '@utils/procedure-surface-selection.utils'
import {
  getAtomicSurfacesForTooth,
  ToothSurfaceArchetype,
} from './Appointment.constant'
import ToothSurfaceRow from './ToothSurfaceRow'

type ToothSurfaceSelectionListProps = {
  selections: IToothDetails[]
  toothSurfaceArchetype: ToothSurfaceArchetype
  requiresSurfaceSelection: boolean
  surfaceRules: ProcedureSurfaceSelectionRules
  onSurfaceToggle: (toothNum: number, surface: string) => void
  onRemove: (toothNum: number) => void
}

const ToothSurfaceSelectionList: React.FC<ToothSurfaceSelectionListProps> = ({
  selections,
  toothSurfaceArchetype,
  requiresSurfaceSelection,
  surfaceRules,
  onSurfaceToggle,
  onRemove,
}) => {
  if (selections.length === 0) {
    return null
  }
  const sorted = [...selections].sort(
    (a, b) => (a.tooth_num ?? 0) - (b.tooth_num ?? 0),
  )
  return (
    <div className="appt-tooth-selection-list">
      {sorted.map((row) => {
        const toothNum = row.tooth_num
        if (toothNum === undefined || toothNum === null) {
          return null
        }
        const availableSurfaces = getAtomicSurfacesForTooth(
          toothNum,
          toothSurfaceArchetype,
        )
        return (
          <ToothSurfaceRow
            key={toothNum}
            toothNum={toothNum}
            selectedSurfaces={row.surf ?? []}
            availableSurfaces={availableSurfaces}
            requiresSurfaceSelection={requiresSurfaceSelection}
            surfaceRules={surfaceRules}
            onSurfaceToggle={onSurfaceToggle}
            onRemove={onRemove}
          />
        )
      })}
    </div>
  )
}

export default ToothSurfaceSelectionList
